import React from 'react';

interface LifeShareLogoProps {
  size?: 'small' | 'medium' | 'large';
  variant?: 'light' | 'dark' | 'default';
  showText?: boolean;
  className?: string;
}

const LifeShareLogo: React.FC<LifeShareLogoProps> = ({
  size = 'medium',
  variant = 'default',
  showText = true,
  className = ''
}) => {
  const getSizeClasses = () => {
    switch (size) {
      case 'small':
        return showText ? 'h-8' : 'h-6 w-6';
      case 'large':
        return showText ? 'h-14' : 'h-12 w-12';
      default:
        return showText ? 'h-10' : 'h-8 w-8';
    }
  };

  const getLogoSrc = () => {
    // Her zaman default logo kullan - daha belirgin
    return '/logo-default.png';
  };

  const getTextSize = () => {
    switch (size) {
      case 'small':
        return 'text-sm';
      case 'large':
        return 'text-2xl';
      default:
        return 'text-lg';
    }
  };

  return (
    <div className={`flex items-center space-x-3 ${className}`}>
      {/* Logo Image */}
      <div className={`${getSizeClasses()} ${!showText ? '' : ''} flex-shrink-0`}>
        <img
          src={getLogoSrc()}
          alt="LifeShare Logo"
          className={`${getSizeClasses()} object-contain rounded-xl shadow-lg ring-1 ring-white/10`}
          style={{
            filter: 'drop-shadow(0 4px 12px rgba(139,92,246,0.2) drop-shadow(0 2px 6px rgba(0,0,0,0.1)',
            transform: 'translateZ(0)' // GPU acceleration
          }}
        />
      </div>

      {/* Logo Text */}
      {showText && (
        <div className="flex flex-col">
          <h1 className={`${getTextSize()} font-bold leading-tight`}>
            <span 
              className="text-gradient-lifeshare"
              style={{
                background: 'linear-gradient(135deg, #8b5cf6 0%, #c084fc 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text'
              }}
            >
              LifeShare
            </span>
          </h1>
          {size !== 'small' && (
            <span className={`${size === 'large' ? 'text-sm' : 'text-xs'} text-gray-400 font-medium`}>
              Admin Panel
            </span>
          )}
        </div>
      )}
    </div>
  );
};

export default LifeShareLogo;
